import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { Button, Stack } from "@mui/material";
import clsx from "clsx";
import { NotificationResource } from "models/Resources/NotificationResource";
import { displayDateTime } from "utils/displayDateTime";

import { NotificationType } from "constants/NotificationConstants";
import ClipBoardTexte from "utils/copyClipboard";
import "../Notifications.scss";
import "./NotificationDetails.scss";

type Props = {
  notification: NotificationResource;
  onNotificationReadClick: (notificationId: string) => void;
  onReturnLogoClick: () => void;
};
export const MARK_AS_READ_BUTTON_MESSAGE = "Bien reçu";
const READ_BUTTON_MESSAGE = "Fermer";

const NotificationDetails: React.FC<Props> = ({
  notification: notification,
  onNotificationReadClick,
  onReturnLogoClick,
}) => {
  const notificationDetailClassName =
    makeNotificationDetailClassName(notification);

  return (
    <Stack className={notificationDetailClassName}>
      <div className="notification-details">
        <div className="return-logo" onClick={onReturnLogoClick}>
          <NavigateBeforeIcon />
        </div>
        <div className="notification-text">
          <div className="notification-time">
            {displayDateTime(notification.sentDate)}
          </div>
          <div className="notification-title" onClick={onReturnLogoClick}>
            <ClipBoardTexte texte={notification.title} />
            </div>
          <div className="notification-text" onClick={onReturnLogoClick}><ClipBoardTexte texte={notification.text} ></ClipBoardTexte></div>
        </div>
      </div>
      {notification.type == NotificationType.IMPORTANT ? (
        <Button
          style={{
            alignSelf: "center",
            width: "50%",
            margin: "10px",
            backgroundColor: "#1976d2",
            color: "white",
          }}
          onClick={() => onNotificationReadClick(notification.notificationId)}>
          {notification.archivedBy
            ? READ_BUTTON_MESSAGE
            : MARK_AS_READ_BUTTON_MESSAGE}
        </Button>
      ) : null}
    </Stack>
  );
};

export default NotificationDetails;

function makeNotificationDetailClassName(
  notification: NotificationResource
): string {
  const className = clsx(
    "notification-text-area",
    `${notification.type}-text`,
    `${notification.severity.toLocaleLowerCase()}-notification`,
    notification.archivedBy && "archived-notification"
  );
  return className;
}
